import React from "react";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
import { Box, Flex } from "rebass";
import { getLocalizedString } from "../../utils";
import { Price } from "../common/Price";

const OrderInfoRow = ({
  label,
  doorId,
  quantity,
  price,
  showAvailability,
  toggleShowAvailability,
  editingMobile,
  isTotal = false,
  ...props
}) => {
  return (
    <Flex
      bg={"#fafafa"}
      width="100%"
      height="45px"
      mb="2px"
      justifyContent={"space-between"}
      alignItems={"center"}
      {...props}
    >
      <Flex
        flexDirection="column"
        padding="4px 4px 0"
        width={"calc((100% / 2) - 60px)"}
      >
        {!isTotal && <Box sx={{ fontSize: "8px" }}>Door</Box>}
        <Box
          sx={{
            fontWeight: "bold",
            borderRight: isTotal ? "1px solid transparent" : "1px solid black",
          }}
        >
          {label}
        </Box>
      </Flex>
      <Flex
        flexDirection="column"
        padding="4px 4px 0"
        width={"calc((100% / 2) - 60px)"}
      >
        {!isTotal && (
          <Box sx={{ fontSize: "8px" }}>{getLocalizedString("QTA")}</Box>
        )}
        <Box
          sx={{
            fontWeight: "bold",
            borderRight: "1px solid black",
          }}
        >
          {quantity || 0}
        </Box>
      </Flex>
      <Flex flexDirection="column" padding="4px 4px 0" width={"120px"}>
        {!isTotal && (
          <Box sx={{ fontSize: "8px" }}>{getLocalizedString("Prezzo")}</Box>
        )}
        <Flex
          sx={{
            fontWeight: "bold",
            justifyContent: "flex-end",
            width: "100%",
          }}
        >
          <Price price={price} />
        </Flex>
      </Flex>
      {
        <Flex
          alignItems="center"
          onClick={() => toggleShowAvailability?.(doorId)}
          sx={{
            px: "5px",
            ...(editingMobile !== null && {
              opacity: 0.6,
              pointerEvents: "none",
            }),
            ...(!!isTotal && {
              pointerEvents: "none",
              visibility: "hidden",
            }),
          }}
        >
          {showAvailability === doorId ? (
            <BsChevronUp size="18px" />
          ) : (
            <BsChevronDown size="18px" />
          )}
        </Flex>
      }
    </Flex>
  );
};

export default OrderInfoRow;
